const KEYCODE_ENTER = 13;

export default class OnEnterController {
  constructor($scope, $element) {
    Object.assign(this, { $scope, $element });

    $element.bind('keypress', (event) => {
      if (event.keyCode === KEYCODE_ENTER) {
        event.preventDefault();

        const scope = this.$scope.$new(false, this.$scope);
        scope.$event = event;
        this.$scope.onEnter(scope);

        return false;
      }
    });
  }
}

OnEnterController.$inject = ['$scope', '$element'];



// WEBPACK FOOTER //
// ./src/modules/utils/lsp-keyboard/components/on-enter/on-enter-controller.js